import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Gift, ArrowRight } from "lucide-react";
import { API } from "../App";
import { useLanguage } from "../contexts/LanguageContext";

const HeroTrialButton = ({ user }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    if (user) return;
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/public/welcome-promo`);
        if (res.data?.active && res.data?.code) setPromo(res.data);
      } catch { /* silent */ }
    };
    fetch();
  }, [user]);

  if (user || !promo) return null;

  const isFr = language === "fr";
  const isFree = (promo.discount_rate || 100) >= 100;

  return (
    <button
      onClick={() => navigate("/auth")}
      data-testid="hero-trial-button"
      className="group inline-flex items-center gap-2 bg-white hover:bg-gray-50 border-2 border-brand-300 text-brand-700 hover:text-brand-800 font-semibold text-sm md:text-base px-6 py-3.5 rounded-lg transition-all"
    >
      <Gift className="h-4 w-4" />
      <span>
        {isFree
          ? isFr ? "Faire l'essai gratuitement" : "Try it free"
          : isFr ? `Faire l'essai · ${promo.discount_rate}% off` : `Try it · ${promo.discount_rate}% off`}
      </span>
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </button>
  );
};

export default HeroTrialButton;
